import { useCallback } from 'react';

import { useAppDispatch } from '@/store/hooks';
import { useJourneyNavigate } from '@/services/journeys/useJourneyNavigate';
import { initOrderReference, setFixedTransactionId, setPaymentSelectFromTransaction } from '@/features/paymentSelect/paymentSelectSlice';
import { setUserDetailsFromTransactionData } from '@/features/userDetails/userDetailsSlice';
import {
  setErrorMessage, setFailureUrl, setSuccessUrl, setTransSourceUrl
} from '@/features/paymentProcess/transactionSlice';

import { useFetchTransaction } from './useFetchTransaction';
import { setClient } from './directPaymentSlice';

export function useLoadTransaction() {
  const dispatch = useAppDispatch();

  const journeyNavigate = useJourneyNavigate();

  const { triggerFetchApi } = useFetchTransaction();

  const loadTransaction = useCallback(async (transactionId: string) => {
    // Return false when transaction does not exist
    if (!transactionId) {
      return false;
    }

    const transactionData = await triggerFetchApi(
      { transactionId },
      {
        onSuccess: () => {},
        onError: () => {
          dispatch(setErrorMessage('Error fetching transaction data'));
          journeyNavigate('error');
        },
      }
    );

    if (!transactionData) {
      dispatch(setErrorMessage('Error fetching transaction data'));
      journeyNavigate('error');
      return false;
    }

    // Init new order reference
    dispatch(initOrderReference());

    // Populate states from transaction data
    dispatch(setFixedTransactionId(transactionId));
    dispatch(setPaymentSelectFromTransaction(transactionData));
    dispatch(setUserDetailsFromTransactionData(transactionData));
    dispatch(setClient(transactionData.client));
    dispatch(setSuccessUrl(transactionData.successUrl));
    dispatch(setFailureUrl(transactionData.failureUrl));
    if (transactionData.transSourceUrl) {
      dispatch(setTransSourceUrl(transactionData.transSourceUrl));
    }

    return true;
  }, [triggerFetchApi, dispatch, journeyNavigate]);

  return loadTransaction;
}
